export default __webpack_public_path__ + "static/media/plus.1eb5b47b.svg";